import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import Button from 'components/common/Button'
import styles from './rsvp-by-host-undecided-to-accepted.scss'
import TicketCountsSelector from './TicketCountsSelector'
import { deepCopyArray } from '../../services/utils'
import RsvpTitle from './RsvpTitle'

const RSVPByHostUndecidedToAccepted = ({
  displayName,
  onConfirm,
  ticketCounts: propTicketCounts,
  ticketTypesCounts,
  onChangeCount,
  guestCountEnabled,
  childCountEnabled
}) => {
  const [showBringGuestModal, setShowBringGuestModal] = useState(true)
  const [showGuestCountControlsModal, setShowGuestCountControlsModal] = useState(false)
  const [ticketCounts, setTicketCounts] = useState(deepCopyArray(propTicketCounts || ticketTypesCounts))

  useEffect(() => {
    setTicketCounts(deepCopyArray(propTicketCounts || ticketTypesCounts))
  }, [propTicketCounts, ticketTypesCounts])

  const handleChangeCount = (id, count) => {
    const newCounts = ticketCounts.map(item =>
      item.id === id ? { ...item, count } : item
    )
    setTicketCounts(newCounts)
    onChangeCount(id, count)
  }

  const handleYes = () => {
    setShowBringGuestModal(false)
    setShowGuestCountControlsModal(true)
  }

  const setAdultOrGuestCountToOne = counts => {
    return counts.map(item =>
      (item.label === 'adult' || item.label === 'guest')
        ? { ...item, count: 1 }
        : item
    )
  }

  const handleNo = () => {
    const newCounts = setAdultOrGuestCountToOne(ticketCounts)
    setTicketCounts(newCounts)
    onConfirm({
      rsvpState: 'accepted',
      ticketCounts: newCounts,
      onSuccess: () => {
        setShowBringGuestModal(false)
        setShowGuestCountControlsModal(false)
      }
    })
  }

  const onClickConfirm = () => {
    onConfirm({ rsvpState: 'accepted', ticketCounts: ticketCounts })
  }

  const _validConfirm = () => {
    const hasValidCount = ticketCounts.some(item =>
      (item.label === 'adult' || item.label === 'guest') && item.count > 0
    )
    return !hasValidCount
  }

  return (
    <div className={styles['container']}>
      {showBringGuestModal && (
        <>
          <RsvpTitle
            title={`${displayName} is Going`}
            subTitle={
              <div className={styles['bring-guest-text']}>
                Is {displayName} bringing any additional guests?
              </div>
            }
          />

          <div className={styles['bring-guest-btn-wrapper']}>
            <Button
              filled={false}
              onClick={handleYes}
            >
              yes
            </Button>
            <Button
              filled={false}
              onClick={handleNo}
            >
              no
            </Button>
          </div>
        </>
      )}
      {showGuestCountControlsModal && (
        <>
          <RsvpTitle
            title={`${displayName} is Going`}
            subTitle={
              <div>
                Including {displayName},
                <br /> How many <strong>total guests</strong> are going?
              </div>
            }
          />

          {
            guestCountEnabled && (
              <TicketCountsSelector
                child_count_enabled={childCountEnabled}
                ticketCounts={ticketCounts}
                onChangeCount={handleChangeCount}
              />
            )
          }

          <Button disabled={_validConfirm()} className={styles['confirm-button']} onClick={onClickConfirm}>
            confirm
          </Button>
        </>

      )}
    </div>
  )
}

RSVPByHostUndecidedToAccepted.propTypes = {
  displayName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  ticketCounts: PropTypes.array,
  ticketTypesCounts: PropTypes.array,
  onChangeCount: PropTypes.func,
  guestCountEnabled: PropTypes.bool,
  childCountEnabled: PropTypes.bool
}

export default RSVPByHostUndecidedToAccepted
